import { useFormContext } from 'react-hook-form';
import React, { DetailedHTMLProps } from 'react';
import { ComponentErrorBoundary } from '@app/utilities';

import { BaseFromProps } from './BaseFromProps';

export function Select<T>({ label, selectOptions, defaultValue, name, options, width, hideLabel = false, ...props }: SelectProps<T>) {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <ComponentErrorBoundary>
      <div className={`${width || 'sixteen'} wide column`}>
        <div className="field">
          <div className="ui labeled input">
            {!hideLabel && <div className="ui label">{label}</div>}
            <div className="ui input">
              <select className="ui fluid dropdown" {...register(name, options)} {...props} defaultValue={defaultValue}>
                <option key="default" value="">
                  Select...
                </option>
                {selectOptions.map((option) => (
                  <option key={option.value} value={option.value} title={option.tooltip}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {!!errors[name] && <div className="ui pointing red basic label">{errors[name]?.message as string}</div>}
        </div>
      </div>
    </ComponentErrorBoundary>
  );
}

export type SelectProps<T> = {
  defaultValue?: string | number;
  selectOptions: SelectOption[];
  hideLabel?: boolean;
} & BaseFromProps<T> &
  DetailedHTMLProps<React.InputHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>;

export type SelectOption = {
  value: string | number;
  label: string | number;
  tooltip?: string;
};

export function toSelectOption(options: string[] | number[]): SelectOption[] {
  return options.map((option: string | number) => ({ value: option, label: option }));
}
